import React from 'react';
import { Input, Button, Select, Row, Col, Space, DatePicker } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const { Option } = Select;
const { RangePicker } = DatePicker;

const SearchCard = ({
  searchPlaceholder = "Search...",
  searchValue = "",
  onSearchChange,
  onSearchClick,
  onKeyPress,
  minSearchLength = 0,
  filters = [],
  actionButtons = [], // Changed from actionButton to actionButtons (array)
  style = {},
  theme = "default" // "default" or "white"
}) => {
  const getThemeStyles = (theme) => {
    if (theme === "white") {
      return {
        background: '#fff',
        border: '1px solid #e8e8e8',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)'
      };
    }
    return {
      background: '#fff',
      boxShadow: '0 1px 4px rgba(0,0,0,0.06)'
    };
  };

  const themeStyles = getThemeStyles(theme);
  
  const cardStyles = `
    .search-container {
      background: ${themeStyles.background};
      padding: 16px;
      border-radius: 8px;
      margin-bottom: 16px;
      box-shadow: ${themeStyles.boxShadow};
      ${themeStyles.border ? `border: ${themeStyles.border};` : ''}
    }
  `;

  const hasFilters = filters && filters.length > 0;
  const hasActionButtons = actionButtons && actionButtons.length > 0;

  return (
    <>
      <style>{cardStyles}</style>
      
      {/* Combined Search and Filters Container */}
      <div className="search-container" style={style}>
        {/* Search Bar */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: hasFilters || hasActionButtons ? '16px' : '0' }}>
          <Input 
            placeholder={searchPlaceholder}
            style={{ flex: 1 }}
            value={searchValue}
            onChange={onSearchChange}
            onPressEnter={onSearchClick}
            onKeyPress={onKeyPress}
          />
          {!hasActionButtons && (
            <Button 
              icon={<SearchOutlined />}
              onClick={onSearchClick}
            >
              Search
            </Button>
          )}
        </div>
        
        {/* Show minimum character requirement message */}
        {minSearchLength > 0 && searchValue.length > 0 && searchValue.length < minSearchLength && (
          <div style={{ 
            marginTop: '8px', 
            marginBottom: hasFilters || hasActionButtons ? '16px' : '0',
            fontSize: '12px', 
            color: '#666',
            fontStyle: 'italic'
          }}>
            Type at least {minSearchLength} characters to search, or press Enter to search anyway
          </div>
        )}

        {/* Filters */}
        {(hasFilters || hasActionButtons) && (
          <Row gutter={[16, 16]} align="middle">
            {/* Render filter selects */}
            {filters.map((filter, index) => (
              <Col key={index}>
                <Space align="center">
                  <span>{filter.label}:</span>
                  {filter.type === 'dateRange' ? (
                    <RangePicker
                      value={Array.isArray(filter.value) && filter.value.some(val => val) ? filter.value : null}
                      onChange={filter.onChange}
                      style={{ width: filter.width || 260 }}
                      allowClear
                      format={filter.format || 'YYYY-MM-DD'}
                    />
                  ) : (
                    <Select
                      value={filter.value}
                      onChange={filter.onChange}
                      style={{ width: filter.width || 120 }}
                      placeholder={filter.placeholder || "View all"}
                    >
                      {(filter.options || []).map(option => (
                        <Option key={option.value || option} value={option.value || option}>
                          {option.label || option}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Space>
              </Col>
            ))}
            
            {/* Action Buttons */}
            {hasActionButtons && (
              <Col flex="auto" style={{ textAlign: 'right' }}>
                <Space>
                  {actionButtons.map((button, index) => (
                    <Button 
                      key={index}
                      type={button.type || "default"}
                      icon={button.icon}
                      onClick={button.onClick}
                    >
                      {button.text}
                    </Button>
                  ))}
                </Space>
              </Col>
            )}
          </Row>
        )}
      </div>
    </>
  );
};

export default SearchCard;